import { render } from "./CheckCont.vue?vue&type=template&id=99d0837a&scoped=true&ts=true"
import script from "./CheckCont.vue?vue&type=script&lang=ts"
export * from "./CheckCont.vue?vue&type=script&lang=ts"

import "./CheckCont.vue?vue&type=style&index=0&id=99d0837a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99d0837a"]])

export default __exports__